
// @ts-nocheck
import locale_en_46json_0b63539c from "#nuxt-i18n/0b63539c";
import locale_fa_46json_52da28b2 from "#nuxt-i18n/52da28b2";
import locale_zh_46json_eb6b6151 from "#nuxt-i18n/eb6b6151";
import locale_es_46json_37bbce7d from "#nuxt-i18n/37bbce7d";
import locale_hi_46json_46a8550f from "#nuxt-i18n/46a8550f";
import locale_ar_46json_223a5e9d from "#nuxt-i18n/223a5e9d";

export const localeCodes =  [
  "en",
  "fa",
  "zh",
  "es",
  "hi",
  "ar"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => Promise.resolve(locale_en_46json_0b63539c),
      cache: true
    }
  ],
  fa: [
    {
      key: "locale_fa_46json_52da28b2",
      load: () => Promise.resolve(locale_fa_46json_52da28b2),
      cache: true
    }
  ],
  zh: [
    {
      key: "locale_zh_46json_eb6b6151",
      load: () => Promise.resolve(locale_zh_46json_eb6b6151),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_37bbce7d",
      load: () => Promise.resolve(locale_es_46json_37bbce7d),
      cache: true
    }
  ],
  hi: [
    {
      key: "locale_hi_46json_46a8550f",
      load: () => Promise.resolve(locale_hi_46json_46a8550f),
      cache: true
    }
  ],
  ar: [
    {
      key: "locale_ar_46json_223a5e9d",
      load: () => Promise.resolve(locale_ar_46json_223a5e9d),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "English",
      files: [
        {
          path: "/app/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fa",
      name: "Farsi",
      files: [
        {
          path: "/app/i18n/locales/fa.json",
          cache: undefined
        }
      ]
    },
    {
      code: "zh",
      name: "Chinese",
      files: [
        {
          path: "/app/i18n/locales/zh.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      name: "Spanish",
      files: [
        {
          path: "/app/i18n/locales/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "hi",
      name: "Hindi",
      files: [
        {
          path: "/app/i18n/locales/hi.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ar",
      name: "Arabic",
      files: [
        {
          path: "/app/i18n/locales/ar.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  ignoreRoutes: [
    "sitemap.xml",
    "sitemap_index.xml",
    "robots.txt"
  ],
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    files: [
      {
        path: "/app/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fa",
    name: "Farsi",
    files: [
      {
        path: "/app/i18n/locales/fa.json",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    name: "Chinese",
    files: [
      {
        path: "/app/i18n/locales/zh.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    name: "Spanish",
    files: [
      {
        path: "/app/i18n/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hi",
    name: "Hindi",
    files: [
      {
        path: "/app/i18n/locales/hi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ar",
    name: "Arabic",
    files: [
      {
        path: "/app/i18n/locales/ar.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/